module.exports = __webpack_public_path__ + "e6bd34d011432df6527ced9370e5de34.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/tiers/wing-5.png
// module id = 3475
// module chunks = 0